/* eslint-disable */
import { defineStore } from 'pinia';
import { useInitializeStore } from './initialize';

export const usePlatformConfigurationStore = defineStore('platform_configuration', {
	state: () => ({
		platform_configuration: [],
	}),
	getters: {
		getPlatformConfiguration(state) {
			return state.platform_configuration
		},
		isRememberMeEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'login_remember_me');
			if (!config) return false; // Explicit default

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 0;
		},
		isResponsibleBettingModalEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'responsible_betting_modal');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isEmailVerificationEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'email_verification');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isCustomerVerificationEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'customer_verification');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isVerificationTabEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'verification_process_tab');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isGhanaSmsVerificationEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'ghana_sms_verification');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isShowNationalIdEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_national_id_number');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isShowCallBubbleEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_call_bubble');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isShowPendingDepositsEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_pending_deposits');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isCompactHeroBannersEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_compact_hero_banners_without_overlays');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isGradientColorOnPromotionsEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_gradient_color_on_promotions');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isTransparentHeaderEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_transparent_homepage_header');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isPasswordUnSafe(state) {
			const config = state.platform_configuration.find(configuration => configuration.name === 'unsafe_password');
			if (!config) return true;

			if (config.value == 'false') return false;
			return true;
		},
		isGradientColorOnLoginRegisterEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_gradient_color_on_login_and_register_page');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showTextInsidePromotions: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_text_inside_promotions');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isMultiThemeSupportEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_theme_support');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isNewPreSportsLayoutEnabled: (state) => {
			const initializeStore = useInitializeStore();
			if (initializeStore.screenWidth > 991) return false;

			const config = state.platform_configuration.find(configuration => configuration.name === 'use_new_pre_sports_mobile_layout');
			if (!config) return false; // Explicit default

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 0;
		},
		isLiveChatHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'live_chat_header');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isBetslipLayerEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_betslip_additional_layer');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;

		},
		isReferralEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_referral_system');
			if (!config) return false;


			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isAcceptAnyOddsEnabledOnBetslip: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'accept_any_odds_on_betslip');
			if (!config) return true;


			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isBetInfluencerEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_bet_influencer_system');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';
		},
		isLaternaEnabled(state) {
			const initializeStore = useInitializeStore();
			// if (initializeStore.screenWidth > 991) return false;
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_new_landing_page_layout');
			if (!config) return false;

			if (config.value == 'false') return false;
			return true;
		},
		hasSmallMobileCasinoBanners(state) {
			const initializeStore = useInitializeStore();
			if (initializeStore.screenWidth > 991) return false;

			const config = state.platform_configuration.find(configuration => configuration.name === 'use_small_mobile_casino_banners');
			if (!config) return false;

			if (config.value == 'false') return false;
			return true;
		},
		hasLargeLandingMenu(state) {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_large_landing_menu');
			if (!config) return false;

			if (config.value == 'false') return false;
			return true;
		},
		showExtendedBonusInfo: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_extended_bonus_info');
			if (!config) return true;
			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';
			return value === 1;
		},
		isAthenaPixelEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_athena_pixel');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isLaternaBannersEnabled(state) {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_laterna_banners');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showWhatsappOnHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_whatsapp_on_header');
			if (!config) return false;

			const value = config.value;
			if (!value) return false;

			return value
		},
		showVerificationWarning: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_verification_warning');

			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showWalletButtonInsteadOfDepositInHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_wallet_button_instead_of_deposit_in_header');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showGoToCasinoAfterDepositButton: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_go_to_casino_after_deposit_button');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		}
	},
	actions: {
		setPlatformConfiguration(data) {
			this.platform_configuration = data;
		}
	},
})